import { Input } from './';
import { dateFormat, parseDate, formatDate } from './common';

import React, { Component } from 'react';
import { get, invoke } from 'lodash';

class DateInput extends Component {
  state = {
    value: formatDate(get(this.props, 'value', '')),
    error: false,
  };

  onChange = (event, { value, ...rest }) => {
    const parsedValue = parseDate(value);
    if (parsedValue) {
      invoke(this.props, 'onChange', event, { value: parsedValue, ...rest });
      this.setState({ error: false });
    }
    this.setState({ value });
  };

  onBlur = () => {
    const { value } = this.state;
    const parsedValue = parseDate(value);
    this.setState({ error: value.length > 0 && !parsedValue });
  };

  render() {
    const { placeholder, ...props } = this.props;
    const { value, error } = this.state;
    return (
      <Input
        {...props}
        value={value || ''}
        error={error}
        //pattern="[1-9]([.0-9]+)?"
        onChange={this.onChange}
        onBlur={this.onBlur}
        placeholder={
          placeholder ? `${placeholder} (${dateFormat})` : dateFormat
        }
      />
    );
  }
}

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/DateInput.js